var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Itinerarios',{on:{"next":_vm.next,"prev":_vm.prev}})
}
var staticRenderFns = []

export { render, staticRenderFns }